import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { VpHookFormInput } from '..';

export const StyledAdornmentBox = styled(Box)(({ backgroundColor, disabled }) => ({
  width: '14px',
  height: '14px',
  backgroundColor,
  cursor: disabled ? 'default' : 'pointer',
  borderRadius: '3px'
}));

export const StyledInputWrapperBox = styled(Box)(({ disabled }) => ({
  width: '100%',
  cursor: disabled ? 'default' : 'pointer'
}));

export const StyledVpHookFormInput = styled(VpHookFormInput)({
  pointerEvents: 'none'
});

export const StyledGridBox = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '10px',
  width: '200px'
});



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpHookFormColorInput/styles.js